import {useAtomValue} from 'jotai';

import {MasterData, masterdataState} from '_/state/masterdata';

export const useMasterdata = (): MasterData => {
  const masterdata = useAtomValue(masterdataState);

  if (!masterdata) {
    throw new Error(
      'Masterdata is undefined. Make sure that masterdata is set before using the "useMasterdata" hook.'
    );
  }
  return masterdata;
};
